import React, { useState } from 'react';
import { arrayOf, bool, number, object, shape, string } from 'prop-types';
import { Box, styled, Tab, Tabs } from '@mui/material';
import TabPanel from '../TabPanel';
import CodeBlock from '../CodeBlock';

const TabbedCodeBlockContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#000',
  position: 'relative',
  borderRadius: theme.border.radius,
  overflow: 'auto',
  padding: theme.spacing(2),
  boxSizing: 'border-box',

  '.MuiTabs-root': {
    borderBottom: `1px solid ${theme.palette.grey[600]}`,
    minHeight: 'unset',

    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.code.text,
      bottom: '-1px',
    },

    button: {
      color: theme.palette.grey[200],
      fontSize: theme.typography.body2.fontSize,
      padding: theme.spacing(1),
      margin: 0,
      fontFamily: theme.typography.bold.fontFamily,

      '&.Mui-selected': {
        color: theme.palette.code.text,
      },

      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
  },

  'pre code': {
    padding: theme.spacing(1, 0),
    whiteSpace: 'pre-wrap',
  },
}));

const TabbedCodeBlock = ({ tabs, defaultTab, styles }) => {
  const [currentTab, setCurrentTab] = useState(defaultTab);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <TabbedCodeBlockContainer sx={styles}>
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
      >
        {tabs.map(({ code, label }, i) => {
          if (!code) {
            return null;
          }
          return (
            <Tab
              key={label}
              label={label}
              value={i}
              active="primary"
            />
          );
        })}
      </Tabs>

      {tabs.map(({ code, label, error }, i) => {
        if (!code) {
          return null;
        }
        return (
          <TabPanel
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            index={i}
            value={currentTab}
            pageName={`${label}-code`}
            boxProps={{ height: '100%' }}
            style={{ height: '100%' }}
          >
            <CodeBlock
              code={code}
              error={error}
              styles={{ padding: 0, overflow: 'unset' }}
            />
          </TabPanel>
        );
      })}
    </TabbedCodeBlockContainer>
  );
};

export default TabbedCodeBlock;

TabbedCodeBlock.propTypes = {
  tabs: arrayOf(
    shape({
      label: string,
      code: string,
      error: bool,
    }),
  ).isRequired,
  defaultTab: number,
  styles: object,
};

TabbedCodeBlock.defaultProps = {
  defaultTab: 0,
  styles: null,
};
